import { FunctionComponent, useState } from "react"
import { Alert, Button, Table } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { HiClipboardCopy, HiOutlineClipboardCopy } from "react-icons/hi"
import { useNavigate } from "react-router-dom"
import FilterDateTimeField from "../components/FilterDateTimeField"
import FilterField from "../components/FilterField"
import { SwipeRecordsQuery, useGetSwipeRecordsQuery } from "../hooks/queries/useGetSwipeRecordsQuery"

interface ISwipeRecordsPage {}
const SwipeRecordsPage: FunctionComponent<ISwipeRecordsPage> = () => {
	const swipeRecordsQuery = useGetSwipeRecordsQuery("swipe-records")
	const swipeRecords = swipeRecordsQuery.data?.swipeRecords
	// loading layout
	const loading = !swipeRecords
	const error = swipeRecordsQuery.error
	if (loading) return <LoadingLayout error={error} />
	// normal layout
	return (
		<Container fluid>
			<h2 className="text-center mt-4">Swipe Records</h2>
			<SwipeRecordsTable swipeRecordsQuery={swipeRecordsQuery} />
			<BackButton />
		</Container>
	)
}
export default SwipeRecordsPage

interface ILoadingLayout {
	error?: string
}
const LoadingLayout: FunctionComponent<ILoadingLayout> = ({ error }) => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Swipe Records</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">Loading</div>
		</Container>
	)
}

interface ISwipeRecordsTable {
	swipeRecordsQuery: SwipeRecordsQuery
}
const SwipeRecordsTable: FunctionComponent<ISwipeRecordsTable> = ({ swipeRecordsQuery: query }) => {
	const swipeRecords = query.data!.swipeRecords
	const [copiedKeycard, setCopiedKeycard] = useState("")
	return (
		<Table striped bordered hover size="sm">
			<thead>
				<tr>
					<th onClick={() => query.sortBy("date")}>Date</th>
					<th onClick={() => query.sortBy("entityName")}>Cardholder</th>
					<th onClick={() => query.sortBy("keycard")}>Keycard</th>
					<th onClick={() => query.sortBy("doorName")}>Door</th>
					<th onClick={() => query.sortBy("type")}>Type</th>
					<th onClick={() => query.sortBy("status")}>Status</th>
				</tr>
				<tr>
					<td>
						<FilterDateTimeField filter={query.dateMinFilter} setFilter={query.setDateMinFilter} label="Min" />
						<FilterDateTimeField
							filter={query.dateMaxFilter}
							setFilter={query.setDateMaxFilter}
							label="Max"
							defaultTime="23:59"
						/>
					</td>
					<td>
						<FilterField
							filter={query.entityFilter}
							setFilter={query.setEntityFilter}
							placeholder="Filter Cardholder"
						/>
					</td>
					<td>
						<FilterField filter={query.keycardFilter} setFilter={query.setKeycardFilter} placeholder="Filter Keycard" />
					</td>
					<td>
						<FilterField filter={query.doorFitler} setFilter={query.setDoorFilter} placeholder="Filter Door" />
					</td>
					<td>
						<FilterField filter={query.typeFilter} setFilter={query.setTypeFilter} placeholder="Filter Type" />
					</td>
					<td>
						<FilterField filter={query.statusFilter} setFilter={query.setStatusFilter} placeholder="Filter Status" />
					</td>
				</tr>
			</thead>
			<tbody>
				{swipeRecords?.map((swipeRecord) => (
					<tr key={swipeRecord.id}>
						<td>{formatDate(swipeRecord.date)}</td>
						<td>{swipeRecord.entityName}</td>
						<td
							onClick={() => {
								navigator.clipboard.writeText(swipeRecord.keycard)
								setCopiedKeycard(swipeRecord.keycard)
							}}>
							{swipeRecord.keycard}
							{copiedKeycard === swipeRecord.keycard ? (
								<HiClipboardCopy style={{ float: "right" }} />
							) : (
								<HiOutlineClipboardCopy style={{ float: "right" }} />
							)}
						</td>
						<td>{swipeRecord.doorName}</td>
						<td>{swipeRecord.type}</td>
						<td>{swipeRecord.status}</td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}

const BackButton: FunctionComponent = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}

const formatDate = (date: string) => {
	const formatter = new Intl.DateTimeFormat("en-US", {
		year: "2-digit",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		hour12: true,
	})
	return formatter.format(new Date(date)).replace(/,/g, "")
}
